// src/components/AboutSection.js
import React from "react";
import "./AboutSection.css";

const AboutSection = () => {
  return (
    <section className="about-section">
      <div className="about-content">
        <div className="paragraph-container">
          <p className="about-paragraph">
            Ubicado junto a la estación de metro de{" "}
            <span className="bold">Patraix</span> y próximo a todos los
            <br />
            servicios, racó patraix combina comodidad y accesibilidad.
          </p>

          <div className="paragraph-divider"></div>

          <p className="about-paragraph">
            El proyecto se compone de <span className="bold">8 viviendas</span>,
            cada una diseñada con especial
            <br />
            atención a la funcionalidad del espacio y la calidad de las
            terminaciones.
          </p>

          <div className="paragraph-divider"></div>

          <p className="about-paragraph">
            La orientación de las viviendas favorece el aprovechamiento de la
            luz
            <br />
            natural y la optimización del confort térmico.
          </p>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
